import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DayNight, DontKnow, Sun } from '../assets'
import SimulationButton from '../components/simulation-button/SimulationButton'
import { MeterType } from '../types'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from 'store/types'
import { updateSimulationInput } from 'store/simulation/actions/updateSimulationInput'
import { nextSimulationStep } from 'store/simulation/actions/switchSimulationStep'
import NavigationButtons from '../components/navigation-buttons/NavigationButtons'
import { SimulationInputKeys } from 'store/simulation/types'
import { trackEvent } from 'utils/eventTracking'
import classNames from 'classnames'
import styles from '../components/simulation-button/SimulationButton.module.scss'
import stepStyles from './Steps.module.scss'

export const MeterTypeStep: FC = () => {
  // REDUX STORE
  const { inputs } = useSelector((state: Store) => state.simulation)
  const dispatch = useDispatch()

  // i18n
  const { t } = useTranslation('simulation')

  /**
   * Handles the simulation button click
   *
   * @param meterType
   */
  const handleSimulationButtonClick = (meterType: MeterType) => {
    // Set hasVat in simulation store
    dispatch(updateSimulationInput({ key: SimulationInputKeys.METER_TYPE, value: meterType }))

    // Track 'Simulation Started' event @Semetis
    trackEvent('simulation_started', {
      step: 'meter-type'
    })

    // Go to next step
    dispatch(nextSimulationStep())
  }

  return (
    <div>
      <div className="is-flex-column is-flex-centered">
        <h2 className={classNames(stepStyles.title, 'margin-top-none', 'margin-bottom-l')}>
          {t('meterTypeTitle', 'Ik heb een ... meter')}
        </h2>
      </div>
      <div className={classNames(styles['simulation-buttons'], styles['is-3'])}>
        <SimulationButton
          title={t('singleMeter', 'Enkelvoudig')}
          icon={<Sun />}
          onClick={() => handleSimulationButtonClick(MeterType.SINGLE_RATE)}
          highlighted={inputs.meterType === MeterType.SINGLE_RATE}
        />

        <SimulationButton
          title={t('doubleMeter', 'Tweevoudig (dag &amp; nacht)')}
          icon={<DayNight />}
          onClick={() => handleSimulationButtonClick(MeterType.DOUBLE_RATE)}
          highlighted={inputs.meterType === MeterType.DOUBLE_RATE}
        />

        <SimulationButton
          title={t('dontKnowMeterType', 'Weet ik niet')}
          icon={<DontKnow />}
          onClick={() => handleSimulationButtonClick(MeterType.SINGLE_RATE)}
          highlighted={false}
        />
      </div>

      <div className="has-text-centered margin-bottom-m">
        <label
          htmlFor="hasExclusiveNight"
          data-for="simulation"
          data-tip="Een exclusief nachtmeter is een aparte meter die bepaalde elektrische toestellen 's nachts van elektriciteit voorziet (zoals accumulatieverwarming of elektrische boilers). Een exclusief nachtmeter komt altijd voor in combinatie met een enkelvoudige of tweevoudige meter"
        >
          <input
            type="checkbox"
            id="hasExclusiveNight"
            checked={inputs.hasExclusiveNightMeter === true}
            onChange={(e) => {
              dispatch(updateSimulationInput({ key: SimulationInputKeys.HAS_EXCLUSIVE_NIGHT_METER, value: e.currentTarget.checked }))
            }}
          />
          &nbsp;
          {t('iHaveExclNight', 'Ik heb ook een exclusieve nachtmeter')}
        </label>
      </div>

      <NavigationButtons nextDisabled={inputs.meterType === null} onNextClick={() => handleSimulationButtonClick(inputs.meterType)} />
    </div>
  )
}
